module.exports = __webpack_public_path__ + "img/shadow--horizontal.ea4f267.png";